import React, { useState } from 'react';
import './CardItem.css';
import { TooltipHost, IconButton } from '@fluentui/react';
import InlineMenu from '../../../InlineMenu/InLineMenu';
import FilterMenusOnState from '../../../../../Utils/State/FilterMenusOnState';

const CardItem = (props) => {
    const [showContextualMenu, updateShowContextualMenu] = useState({
        visible: false,
        target: '',
    });
    const [selected, setSelected] = useState(false);

    const calloutProps = { gapSpace: 10 };
    let tooltipId = 1;

    const menuClickHandler = (event) => {
        updateShowContextualMenu({ visible: true, target: event.target });
    };

    const closeMenuHandler = () => {
        updateShowContextualMenu({ visible: false, target: '' });
    };

    const cardClicked = () => {
        props.itemSelected(props.cardId, props.data, !selected);
        setSelected(selected ? false : true);
    };

    const cardDoubleClicked = () => {
        props.itemInvokedHandler();
    };

    if (selected && props.cardId !== props.selectedItem) {
        setSelected(false);
    }

    let menuItems = FilterMenusOnState(props.menuItems, props.data.stateid);
    menuItems = menuItems.filter((item) => {
        return item.primaryAction !== undefined;
    });
    let iconMenuItems = menuItems.slice(0, 3);

    return (
        <React.Fragment>
            <div
                onClick={() => {
                    cardClicked();
                }}
                onDoubleClick={() => {
                    cardDoubleClicked();
                }}
                className={selected ? 'carditem-selected' : 'carditem-content'}
            >
                <div className="carditem-iconbar">
                    {iconMenuItems.map((item, index) => {
                        if (item.primaryAction) {
                            return (
                                <TooltipHost
                                    key={index}
                                    content={item.text}
                                    id={tooltipId++}
                                    calloutProps={calloutProps}
                                >
                                    <IconButton
                                        iconProps={item.iconProps}
                                        onClick={item.onClick}
                                        styles={{
                                            root: {
                                                height: '20px',
                                                verticalAlign: 'middle',
                                            },
                                        }}
                                    />
                                </TooltipHost>
                            );
                        } else {
                            return null;
                        }
                    })}
                    <TooltipHost
                        content="More"
                        id={tooltipId++}
                        calloutProps={calloutProps}
                    >
                        <IconButton
                            iconProps={{ iconName: 'More' }}
                            onClick={(event) => menuClickHandler(event)}
                            styles={{
                                root: {
                                    height: '20px',
                                    verticalAlign: 'middle',
                                },
                            }}
                        />
                    </TooltipHost>
                </div>
                {props.keys.map((key, index) => {
                    let fieldName = null;
                    let fieldIndex = props.fieldNames.findIndex((fieldName) => {
                        return fieldName.key === key;
                    });
                    if (fieldIndex !== -1) {
                        fieldName = props.fieldNames[fieldIndex].name;
                        return (
                            <div key={index} className="carditem-field">
                                <div className="carditem-itemname">
                                    {fieldName}:
                                </div>
                                <div className="carditem-itemvalue">
                                    {props.data[key]}
                                </div>
                            </div>
                        );
                    } else {
                        return null;
                    }
                })}
            </div>
            <InlineMenu
                showMenu={showContextualMenu.visible}
                closeMenu={closeMenuHandler}
                target={showContextualMenu.target}
                items={menuItems}
            ></InlineMenu>
        </React.Fragment>
    );
};

export default CardItem;
